import { styled } from "@mui/material/styles";

export const Root = styled("div", {
  shouldForwardProp: (prop) => prop !== "aspectRatio",
})(({ aspectRatio }) => ({
  top: "0",
  left: "0",
  width: "100%",
  height: "100%",
  background: "black",
  overflow: "hidden",
  position: "relative",
  aspectRatio,
}));

export const Video = styled("video")({
  width: "100%",
  height: "100%",
});
